var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerContainer"},[_c('div',{attrs:{"id":"bannerBg"}},[_c('div',[_c('p',{attrs:{"id":"bannerTitle"}},[_vm._v("智慧水务解决方案")]),_c('ul',{attrs:{"id":"bannerText"}},[_c('li',[_c('span'),_vm._v("降低产销差解决方案")]),_c('li',[_c('span'),_vm._v("安全供水解决方案")]),_c('li',[_c('span'),_vm._v("节约供水能耗")])])])])])
}]

export { render, staticRenderFns }